/* exclude errors that should not be tracked by sentry */

export const cleanErrors = (errorEvent, error) => {
    const is401Error = (error && error.isRefreshTokenExpired && error.status === 401)
    if (is401Error) {
        console.log(`The error ${JSON.stringify(error)} will not be tracked by Sentry`);
        return;
    }
    return errorEvent; // pass errorEvent back to sentry
}